import appcolors from "./constants/Colors";

const globalStyle = {
  textField: {
    "&.MuiFormControl-root .MuiOutlinedInput-root .MuiInputBase-input": {
      padding: "12px 14px",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px",
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${appcolors.slateGrey}}`,
        // boxShadow:"none !important",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${appcolors.slateGrey} !important}`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${appcolors.slateGrey} !important}`,
      },
    },
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
      marginTop: 0,
    },
    // "&.MuiFormControl-root .MuiInputBase-multiline ": {
    //   padding: 0,
    // },
    "& .Mui-disabled": {
      cursor: "not-allowed",
    },
  },

  selectType: {
    "&.MuiFormControl-root .MuiOutlinedInput-root": {
      borderRadius: "0px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid #7922D8`,
      boxShadow: "0px 4px 10px 0px #ebebeb",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: `1px solid #7922D8`,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: `1px solid #7922D8`,
    },
  },

  customSelect: {
    "&.MuiFormControl-root .MuiOutlinedInput-root .MuiInputBase-input": {
      padding: "8px",
      fontSize: "0.875rem"
    },
    "& .MuiInputBase-input": {
      textTransform: "capitalize",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #a1a1a1}`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #a1a1a1 !important}`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #a1a1a1 !important}`,
      },
    },
  },

  selectDropDown: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px",
      "& .MuiOutlinedInput-input": {
        padding: "12px",
      },
      "& .MuiSelect-multiple": {
        overflow: "hidden",
        whiteSpace: "normal",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        display: "inline-block",
        verticalAlign: "middle",
        lineHeight: "1.5",
        paddingRight: "24px",
        "&:focus": {
          backgroundColor: "transparent",
        },
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${appcolors.slateGrey}}`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${appcolors.slateGrey} !important}`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${appcolors.slateGrey} !important}`,
      },

    },
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
      marginTop: 0,
    },
  },
};

export default globalStyle;
